import script from "./UTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./UTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./UTooltip.vue?vue&type=style&index=0&id=92585cf2&lang=scss"

const __exports__ = script;

export default __exports__